<template>
    <v-lightbox is-authenticated maxed :show="show" foot-class="justify-center" @close="closeLightbox()">
        <template v-slot:trigger>
            <button hidden class="hidden"></button>
        </template>
        <template v-slot:head>
            <v-icon icon="phone" size="8" class="rl-2.5 max-h-[1.5rem]"></v-icon>
            <div class="text-heading-3-desktop">Nastavite telefonsko številko</div>
        </template>
        <template v-slot:content>
            <div class="flex flex-col items-center min-h-[35vh]" v-if="step == 'submit-phone'">
                <figure class="flex gap-3 w-full">
                    <div class="w-1/2">
                        <v-select
                            class="v-select--xs w-full appearance-none rounded-full border-0 p-0 font-medium text-black-78 ring-1 ring-inset ring-gray placeholder:text-black-40 focus-within:ring-2 focus-within:ring-green"
                            :options="phoneOptions"
                            placeholder="Država"
                            v-model="phoneOption"
                            label="custom_label"
                            @search:focus="onFocus"
                            @search:blur="onBlur"
                            ref="phone"
                            id="phone"
                            :name="'phone'"
                        >
                            <template v-slot:no-options>
                                Za ta iskalni niz ni zadetkov.
                            </template>
                        </v-select>
                        <input
                            type="hidden"
                            name="userPhoneCountryCode"
                            :value="
                                phoneOption == null
                                    ? ''
                                    : phoneOption.value
                            "
                        />
                    </div>
                    <div class="w-1/2">
                        <v-form-input
                            id="userPhone"
                            label="Telefonska številka"
                            type="tel"
                            pattern="[0-9]"
                            required="required"
                            name="userPhone"
                            v-model="userPhone"
                        ></v-form-input>
                    </div>
                </figure>
                <div class="text-salmon-medium  mt-4" v-if="error">
                    {{ error }}
                </div>
                <div class="text-body-regular text-black-40 mt-4">
                    Na vašo telefonsko številko vam bomo poslali
                    6-mestno verifikacijsko kodo
                </div>
            </div>
            <div v-if="step == 'submit-code'" class="min-h-[35vh]">
                <figure class="flex justify-between gap-3">
                    <v-form-input v-for="(input, index) in inputs"
                        :key="index"
                        :id="`verify-char-${index}`"
                        :name="`verifyChar${index + 1}`"
                        class="single-digit"
                        v-model="input.value"
                        :value="input.value"
                        label=" "
                        :force-hide-label="true"
                        @paste="handlePaste(index, $event)"
                        @input="handleInput(index)"
                        @keydown="handleKeydown(index, $event)"
                        :ref="`pinInput_${index}`"
                        type="number"
                    ></v-form-input>
                </figure>
                <div class="text-salmon-medium  mt-4" v-if="error">
                    {{ error }}
                </div>
                <div class="text-body-regular text-black-40 mt-4">
                    Vpišite 6.mestno verifikacijsko kodo, ki smo vam
                                jo poslali na vašo telefonsko številko
                </div>
            </div>
        </template>
        <template v-slot:foot>
            <template v-if="submitEnabled">
                <a class="flex button" @click="submit()">
                    <v-icon icon="edit"></v-icon>
                    {{this.step == 'submit-phone' ? 'Pošlji verifikacijsko kodo' : 'Oddaj kodo'}}
                </a>
            </template>
            <template v-else>
                <a class="flex button button--gray cursor-not-allowed" @click="event.preventDefault()">
                    <v-icon icon="edit"></v-icon>
                    {{this.step == 'submit-phone' ? 'Pošlji verifikacijsko kodo' : 'Oddaj kodo'}}
                </a>
            </template>

        </template>
    </v-lightbox>
</template>

<script>
export default {
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        phoneCodes: {
            type: Object,
            required: true,
        },
        sendSmsRoute: {
            type: String,
            required: true,
        },
        processSmsRoute: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            phoneOption: {
                value: "SI",
                custom_label: "Slovenia",
            },
            hidePhoneLabel: false,
            userPhone: "",
            submitting: false,
            step: "submit-phone",
            error: "",
            inputs: Array.from({ length: 6 }, () => ({ value: '' })),
        };
    },
    computed: {
        phoneOptions() {
            let parsedPhones = [];

            Object.values(this.phoneCodes).forEach((object) => {
                parsedPhones.push({
                    value: object.code,
                    custom_label: object.name,
                });
            });

            return parsedPhones;
        },
        submitEnabled() {
            if(this.submitting)
                return false;

            if(!this.phoneOption)
                return false;

            if(this.userPhone == "")
                return false;

            return true;
        },
    },
    methods: {
        handlePaste(inputIndex, event) {
            const clip = event.clipboardData.getData('text');
            const sanitizedClip = clip.replace(/\s/g, "");
            const characters = [...sanitizedClip];

            characters.forEach((char, i) => {
                if (i < this.inputs.length) {
                    this.inputs[i].value = char;
                }
            });

            // Focus on the next input
            if (inputIndex < this.inputs.length - 1) {
                const nextInputRef = this.$refs[`pinInput_${inputIndex + 1}`][0]
                const nextInputInnerRef = nextInputRef.$refs.formInput.$el
                nextInputInnerRef.focus()
            }
        },

        handleInput(inputIndex) {
            // Handle typing, focus on the next input
            const currentInputRef = this.$refs[`pinInput_${inputIndex}`][0]
            const currentInputInnerRef = currentInputRef.$refs.formInput.$el

            if (inputIndex < this.inputs.length - 1 && currentInputInnerRef.value) {
                const nextInputRef = this.$refs[`pinInput_${inputIndex + 1}`][0]
                const nextInputInnerRef = nextInputRef.$refs.formInput.$el
                nextInputInnerRef.focus()
            }
        },

        handleKeydown(inputIndex, event) {
            const elInput = this.$refs[`pinInput_${inputIndex}`][0].$refs.formInput.$el

            if (!elInput.value && event.key === "Backspace" && inputIndex > 0) {
                // Handle deleting, focus on the previous input
                const previousInputRef = this.$refs[`pinInput_${inputIndex - 1}`][0]
                const previousInputInnerRef = previousInputRef.$refs.formInput.$el
                previousInputInnerRef.focus()
            }
        },
        closeLightbox() {
            this.$emit("close"); // emit 'close' event to parent
        },
        termsCheckedChanged(checked) {
            this.termsChecked = checked;
        },
        onFocus() {
            this.hidePhoneLabel = true;
        },
        onBlur() {
            this.hidePhoneLabel = false;
        },
        submit() {
            this.submitting = true;
            this.error = "";
            if(this.step == 'submit-phone') {
                this.submitPhoneNumber();
            } else {
                this.submitCode();
            }
        },
        submitPhoneNumber() {
            let data = {
                country_code: this.phoneOption.value,
                phone: this.userPhone
            };


            let header = {
                headers: {
                "X-CSRF-TOKEN": this.$csrfToken,
                },
            };

            axios.post(this.sendSmsRoute, data, header).then(
                (response) => {
                    if (response.data.success) {
                        this.step = "submit-code";
                        this.submitting = false;
                        return;
                    }
                    this.$emit("confirmed");
                },
                (error) => {
                    this.error = "Preverite telefonsko številko in poskusite znova"
                    this.submitting = false;
                }
            );
        },
        submitCode() {
            let data = {
                verifyChar1: this.inputs[0].value,
                verifyChar2: this.inputs[1].value,
                verifyChar3: this.inputs[2].value,
                verifyChar4: this.inputs[3].value,
                verifyChar5: this.inputs[4].value,
                verifyChar6: this.inputs[5].value,
            };


            let header = {
                headers: {
                "X-CSRF-TOKEN": this.$csrfToken,
                },
            };

            axios.post(this.processSmsRoute, data, header).then(
                (response) => {
                    this.$emit("confirmed");
                },
                (error) => {
                    this.error = error.response?.data?.message ?? "Težava pri oddaji kode. Osvežite stran in poskusite znova";
                    this.submitting = false;
                }
            );
        }
    },
};
</script>
